import styles from './SearchContainer.scss';
import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';
import QuickMenu from 'common/components/QuickMenu/QuickMenu';
import { locationShape } from 'react-router';
import { isEmpty, get, debounce } from 'lodash';
import {
    setSearchPlaceholderText,
    setQuery,
    setFilterOptions,
    setFilter2Options,
    setSortOptions,
    setSortOrderOptions
} from 'common/actions/searchContainerActions';


export class SearchContainer extends Component {
    constructor(props, context) {
        super(props);

        this._updateLocation = debounce(this._updateLocation.bind(this), 300);
        this.state = {
            location: {},
        };

        if (props.location) {
            context.location = props.location;
        }

        if (props.router) {
            context.router = props.router;
        }
    }

    _updateLocation(location) {
        if (this.context && this.context.router && this.context.router.push ) {
            return this.context.router.push(location);
        }
    }

    updateLocation(newLocation) {
        this.setState(function () {
            return {
                location: newLocation,
            };
        });
        this._updateLocation(newLocation);
    }

    searchEventHandler(e) {
        const { setQuery } = this.props;
        const { location } = this.context;
        const { value } = e.target;

        const newLocation = lodash.cloneDeep(location);
        newLocation.query = {
            ...newLocation.query,
            q: value
        };

        setQuery(value);

        this.updateLocation(newLocation);
    }

    setQueryStringParameter(key, value) {
        const { location } = this.state;
        const newLocation = lodash.cloneDeep(location);
        newLocation.query = {
            ...newLocation.query,
            [key]: value
        };
        return () => {
            this.updateLocation(newLocation);
        };
    }

    componentDidMount() {
        const { location } = this.context;
        if (location.query) {
            let queryText = get(location.query, 'q', null);
            this.props.setQuery(queryText);
        }
        this.updateLocation(location);
    }

    componentWillUnmount() {
        const { location } = this.state;
        if (location.query) {
            this.props.setQuery('');
            this.props.setFilterOptions([]);
            this.props.setFilter2Options([]);
            this.props.setSortOptions([]);
            this.props.setSortOrderOptions([]);
        }
    }

    getHeaders() {
        const { filterOptions, filter2Options, sortOptions, sortOrderOptions } = this.props;
        const { location: { query: { filter, filter2, sort, order } } } = this.context;

        const filterHeader = lodash.find(filterOptions, { gqlName: filter }) || filterOptions[0];
        const filter2Header = lodash.find(filter2Options, { gqlName: filter2 }) || filter2Options[0];
        const sortHeader = lodash.find(sortOptions, { gqlName: sort }) || sortOptions[0];
        const sortOrderHeader = lodash.find(sortOrderOptions, { gqlName: order }) || sortOrderOptions[0];

        return {
            filterHeader: filterHeader ? `Show ${filterHeader.displayName}` : '',
            filter2Header: filter2Header ? `Show ${filter2Header.displayName}` : '',
            sortHeader: sortHeader ? `Sort ${sortHeader.displayName}` : '',
            sortOrderHeader: sortOrderHeader ? `By ${sortOrderHeader.displayName}` : '',
        };

    }

    render() {
        const { query, filterOptions, filter2Options, sortOptions, sortOrderOptions } = this.props;

        const filters = filterOptions.map(fo => {
            return {
                label: fo.displayName,
                handler: this.setQueryStringParameter('filter', fo.gqlName)
            };
        });

        const filters2 = filter2Options.map(fo => {
            return {
                label: fo.displayName,
                handler: this.setQueryStringParameter('filter2', fo.gqlName)
            };
        });
        const sorts = sortOptions.map(so => {
            return {
                label: so.displayName,
                handler: this.setQueryStringParameter('sort', so.gqlName)
            };
        });
        const sortOrders = sortOrderOptions.map(so => {
            return {
                label: so.displayName,
                handler: this.setQueryStringParameter('order', so.gqlName)
            };
        });
        const { filterHeader, filter2Header, sortHeader, sortOrderHeader } = this.getHeaders();

        return (
            <div className={styles.searchBar} data-cy="SearchContainer">
                <div className={styles.searchIcon} />
                <input className={styles.searchBox}
                    type="text"
                    placeholder={this.props.placeholderText}
                    value={query || ''} onChange={this.searchEventHandler.bind(this)} 
                    data-cy="SearchContainer-searchBox"/>
                <div className={styles.controls}>
                    <QuickActionControlMenu header={filter2Header} options={filters2} />
                    <QuickActionControlMenu header={filterHeader} options={filters} />
                    <QuickActionControlMenu header={sortHeader} options={sorts} />
                    <QuickActionControlMenu header={sortOrderHeader} options={sortOrders} />
                </div>
            </div>
        );
    }
}

const QuickActionControlMenu = ({ header, options }) => {
    if (isEmpty(options)) {
        return null;
    }

    return (
        <div className={styles.control} data-cy="QuickActionControlMenu">
            <QuickMenu headerText={header} theme="secondary" options={options} />
        </div>
    );
};

SearchContainer.contextTypes = {
    router: PropTypes.object.isRequired,
    location: locationShape.isRequired
};

export default connect((state, props) => {
    const placeholderText = lodash.get(state, 'app.search.placeholderText', 'Search overall binders by name, contact, status, etc.');
    const query = lodash.get(state, 'app.search.query', '');
    const filterOptions = lodash.get(state, 'app.search.filterOptions', []);
    const filter2Options = lodash.get(state, 'app.search.filter2Options', []);
    const sortOptions = lodash.get(state, 'app.search.sortOptions', []);
    const sortOrderOptions = lodash.get(state, 'app.search.sortOrderOptions', []);
    return {
        placeholderText,
        query,
        filterOptions,
        filter2Options,
        sortOptions,
        sortOrderOptions
    };
}, {
    setSearchPlaceholderText,
    setQuery,
    setFilterOptions,
    setFilter2Options,
    setSortOptions,
    setSortOrderOptions
})(SearchContainer);
